import React from "react";

const Buttons = () => {
  return (
    <div class="flex w-full flex-col gap-8">
      <fieldset className="border-dashed flex items-center rounded-[48px] border-[--white-10] border-[1px]">
        <legend className="ml-12 bg-[--white-05] max-w-fit font-bold py-2 px-4 rounded-full text-[--information] mt-4">
          Primary
        </legend>
        <div className=" w-1/5 gap-4   p-4 flex flex-col justify-center rounded-lg">
          <button data-button-type="primary">Add Athlete</button>
          <button data-button-type="primary" disabled>
            Add Athlete
          </button>
        </div>
      </fieldset>
      <fieldset className="border-dashed flex items-center rounded-[48px] border-[--white-10] border-[1px]">
        <legend className="ml-12 bg-[--white-05] max-w-fit font-bold py-2 px-4 rounded-full text-[--information] mt-4">
          Outline
        </legend>
        <div className=" w-1/5 gap-4 flex-col  p-4 flex justify-center rounded-lg">
          <button data-button-type="outline">Add Athlete</button>
          <button data-button-type="outline" disabled>
            <span>Add Athlete</span>
          </button>
        </div>
      </fieldset>
      <fieldset className="border-dashed flex items-center rounded-[48px] border-[--white-10] border-[1px]">
        <legend className="ml-12 bg-[--white-05] max-w-fit font-bold py-2 px-4 rounded-full text-[--information] mt-4">
          Text
        </legend>
        <div className=" w-1/5 gap-4 flex-col  p-4 flex justify-center rounded-lg">
          <button data-button-type="text">Add Athlete</button>
          <button data-button-type="text" disabled>
            <span>Add Athlete</span>
          </button>
        </div>
      </fieldset>
      <fieldset className="border-dashed flex items-center rounded-[48px] border-[--white-10] border-[1px]">
        <legend className="ml-12 bg-[--white-05] max-w-fit font-bold py-2 px-4 rounded-full text-[--information] mt-4">
          Secondary
        </legend>
        <div className=" w-1/5 gap-4 flex-col  p-4 flex justify-center rounded-lg">
          <button data-button-type="secondary">Add Athlete</button>
          <button data-button-type="secondary" disabled>
            Add Athlete
          </button>
        </div>
      </fieldset>
      <fieldset className="border-dashed flex items-center rounded-[48px] border-[--white-10] border-[1px]">
        <legend className="ml-12 bg-[--white-05] max-w-fit font-bold py-2 px-4 rounded-full text-[--information] mt-4">
          Tertiary
        </legend>
        <div className=" w-1/5 gap-4 flex-col  p-4 flex justify-center rounded-lg">
          <button data-button-type="tertiary">Add Athlete</button>
          <button data-button-type="tertiary" disabled>
            Add Athlete
          </button>
        </div>
      </fieldset>
      <fieldset className="border-dashed flex items-center rounded-[48px] border-[--white-10] border-[1px]">
        <legend className="ml-12 bg-[--white-05] max-w-fit font-bold py-2 px-4 rounded-full text-[--information] mt-4">
          Text-white
        </legend>
        <div className=" w-1/5 gap-4 flex-col  p-4 flex justify-center rounded-lg">
          <button data-button-type="text-white">Add Athlete</button>
          <button data-button-type="text-white" disabled>
            Add Athlete
          </button>
        </div>
      </fieldset>
    </div>
  );
};

export default Buttons;
